import { BranchType, WorkshopService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const workshopAppointmentTypeQueryKey = 'WorkshopAppointmentTypeQuery';

export type WorkshopAvailabilitiesLabourInput = {
  from?: string;
  to?: string;
  branch?: BranchType;
};

const fetchWorkshopAppointmentTypeQuery = async (input?: WorkshopAvailabilitiesLabourInput) => {
  const data = await WorkshopService.getWorkshopAppointmentsAvailableSlots(input?.from, input?.to, input?.branch);
  return data;
};

export const useWorkshopAppointmentTypeQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input?: WorkshopAvailabilitiesLabourInput,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof WorkshopService.getWorkshopAppointmentsAvailableSlots>>,
      QueryError,
      Awaited<ReturnType<typeof WorkshopService.getWorkshopAppointmentsAvailableSlots>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [workshopAppointmentTypeQueryKey, ...(queryKey ?? []), input],
    () => fetchWorkshopAppointmentTypeQuery(input),
    options
  );
